import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
//加载swiper
export default {
  install() {
    Vue.use(VueAwesomeSwiper);
  },
};
